// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OpponentMeta__meta-dbc1f5 {
  position: absolute;
  inset-inline-start: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  max-width: calc(100% - 16px);
  gap: 8px;
}

.OpponentMeta__minimize-b8097e {
  inset-inline-start: 8px;
  top: 8px;
  bottom: initial;
}

.OpponentMeta__meta-group-f248ee {
  background-color: var(--addition-110_70);
  border-radius: 13px;
  padding: 0 8px;
  display: flex;
  overflow: hidden;
  flex: 0 1 auto;
  align-items: center;
  height: 26px;
}

.OpponentMeta__meta-group-f248ee:last-child {
  margin-inline-end: 0;
}

.OpponentMeta__name-e0efe1 {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-inline-end: 6px;
  font: var(--font-subtitle-3);
  color: var(--addition-50);
}

.OpponentMeta__name-e0efe1:last-child {
  margin-inline-end: 0;
}

.OpponentMeta__muted-a84498 {
  flex: 0 0 auto;
  fill: var(--addition-50);
}

.OpponentMeta__hand-raised-a79e56 {
  fill: var(--color-icon-default);
  flex: 0 0 auto;
}

.OpponentMeta__hand-raised-with-number-a8ea76 {
  margin-inline-end: 4px;
}

.OpponentMeta__hand-raised-container-a00ceb {
  height: 26px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: var(--addition-130);
  flex: 0 0 auto;
}

.OpponentMeta__hand-raised-container-with-number-f554ac {
  border-radius: 16px;
}

.OpponentMeta__hand-raised-number-c1cc48 {
  font: var(--font-subtitle-2);
}

.OpponentMeta__active-ecfa01 {
  margin: 0;
}

.OpponentMeta__sharing-icon-ee5f50 {
  border-radius: 50%;
  fill: var(--addition-50);
  margin-inline-end: 6px;
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/OpponentVideo/OpponentMeta/OpponentMeta.styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,4BAAA;EACA,QAAA;AACF;;AAEA;EACE,uBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,wCAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4BAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,wBAAA;AACF;;AAEA;EACE,+BAAA;EACA,cAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,cAAA;AACF","sourcesContent":[".meta {\n  position: absolute;\n  inset-inline-start: 8px;\n  bottom: 8px;\n  display: flex;\n  align-items: center;\n  max-width: calc(100% - 16px);\n  gap: 8px;\n}\n\n.minimize {\n  inset-inline-start: 8px;\n  top: 8px;\n  bottom: initial;\n}\n\n.meta-group {\n  background-color: var(--addition-110_70);\n  border-radius: 13px;\n  padding: 0 8px;\n  display: flex;\n  overflow: hidden;\n  flex: 0 1 auto;\n  align-items: center;\n  height: 26px;\n}\n\n.meta-group:last-child {\n  margin-inline-end: 0;\n}\n\n.name {\n  display: block;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-inline-end: 6px;\n  font: var(--font-subtitle-3);\n  color: var(--addition-50);\n}\n\n.name:last-child {\n  margin-inline-end: 0;\n}\n\n.muted {\n  flex: 0 0 auto;\n  fill: var(--addition-50);\n}\n\n.hand-raised {\n  fill: var(--color-icon-default);\n  flex: 0 0 auto;\n}\n\n.hand-raised-with-number {\n  margin-inline-end: 4px;\n}\n\n.hand-raised-container {\n  height: 26px;\n  padding: 0 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: var(--addition-130);\n  flex: 0 0 auto;\n}\n\n.hand-raised-container-with-number {\n  border-radius: 16px;\n}\n\n.hand-raised-number {\n  font: var(--font-subtitle-2);\n}\n\n.active {\n  margin: 0;\n}\n\n.sharing-icon {\n  border-radius: 50%;\n  fill: var(--addition-50);\n  margin-inline-end: 6px;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"meta": `OpponentMeta__meta-dbc1f5`,
	"minimize": `OpponentMeta__minimize-b8097e`,
	"meta-group": `OpponentMeta__meta-group-f248ee`,
	"metaGroup": `OpponentMeta__meta-group-f248ee`,
	"name": `OpponentMeta__name-e0efe1`,
	"muted": `OpponentMeta__muted-a84498`,
	"hand-raised": `OpponentMeta__hand-raised-a79e56`,
	"handRaised": `OpponentMeta__hand-raised-a79e56`,
	"hand-raised-with-number": `OpponentMeta__hand-raised-with-number-a8ea76`,
	"handRaisedWithNumber": `OpponentMeta__hand-raised-with-number-a8ea76`,
	"hand-raised-container": `OpponentMeta__hand-raised-container-a00ceb`,
	"handRaisedContainer": `OpponentMeta__hand-raised-container-a00ceb`,
	"hand-raised-container-with-number": `OpponentMeta__hand-raised-container-with-number-f554ac`,
	"handRaisedContainerWithNumber": `OpponentMeta__hand-raised-container-with-number-f554ac`,
	"hand-raised-number": `OpponentMeta__hand-raised-number-c1cc48`,
	"handRaisedNumber": `OpponentMeta__hand-raised-number-c1cc48`,
	"active": `OpponentMeta__active-ecfa01`,
	"sharing-icon": `OpponentMeta__sharing-icon-ee5f50`,
	"sharingIcon": `OpponentMeta__sharing-icon-ee5f50`
};
module.exports = ___CSS_LOADER_EXPORT___;
